/* eslint-disable import/no-cycle */
import TabsContentComponent from '../../components/TabsContentComponent';
import { logger } from '../../utils';
import { CType } from '../../models/Contentful/types';
import { TabsContentComponentProps } from './@types';

const TabbedContent: React.FC<CType<TabsContentComponentProps>> = props => {
  try {
    const {
      fields: { ...data },
    } = props;
    return <TabsContentComponent {...data} />;
  } catch (error) {
    logger.error(error);
    return null;
  }
};
export default TabbedContent;
